export default __webpack_public_path__ + "media/images/new_year/hero_3apartments-2bd55a2a29dde2c320e087650ff2df30.png";